export const openPage = (url: string) => window.open(url, '_blank') || window.location.assign(url);
